<label for="code" class="flex flex-col gap-1">
  <span class="text-md">{{ 'auth.otpCode' | translate }}</span>
  <p-inputotp
    #code
    [formControl]="control()"
    [integerOnly]="true"
    [length]="environment.OTP_LENGTH"
  ></p-inputotp>
  @if (formattedTimerValue()) {
    <p class="text-light text-md">
      {{ 'auth.otpExpiresIn' | translate }}: {{ formattedTimerValue() }}
    </p>
  }
</label>
